
import { useState } from "react";
import "./App.css";
import Alert from "./components/Alert";
import About from "./components/About";
import Navbar from "./components/Navbar";
import TextArea from "./components/TextArea";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

function App() {


  const [mode, setMode] = useState('light');
  const [modeTxt, setModeTxt] = useState('Enable Dark Mode');
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type
    })

    setTimeout(() => {
      setAlert(null);
    }, 1500);
  }

  const removeLightClasses = () => {
    document.getElementById("nav").classList.add("navbarDark");
    document.getElementById("nav").classList.remove("navbarLight");
  }
  const removeDarkClasses = () => {
    document.getElementById("nav").classList.remove("navbarDark");
    document.getElementById("nav").classList.add("navbarLight");
  }

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      setModeTxt('Enable Light Mode');
      showAlert('Dark Mode Enabled', "success");
      removeLightClasses();
      document.body.style.backgroundColor = '#212529';
      document.getElementById("myBox").classList.add("textareaDark");
      document.getElementById("myBox").classList.remove("textareaLight");
      document.getElementById("nav").classList.add("navbarDark");
      document.getElementById("nav").classList.remove("navbarLight");

    }
    else {
      setMode('light');
      setModeTxt('Enable Dark Mode');
      showAlert('Light Mode Enabled', "success");
      removeDarkClasses();
      document.body.style.backgroundColor = '#ecf0f3';
      document.getElementById("myBox").classList.remove("textareaDark");
      document.getElementById("myBox").classList.add("textareaLight");
      document.getElementById("nav").classList.remove("navbarDark");
      document.getElementById("nav").classList.add("navbarLight");
    }
  }


  return (
    <>
      <Router>
        <Navbar title="Textutils" aboutText="About Textutils" modeTxt={modeTxt} mode={mode} toggleMode={toggleMode} />
        <Alert alert={alert} />
        <div className="container ">

          <Switch>
            <Route exact path="/about">
              <About mode={mode} />
            </Route>
            <Route exact path="/">
              <TextArea showAlert={showAlert} heading="Try TextUtils - Word Counter | Character Counter | Remove Extra Spaces" mode={mode} />
            </Route>
          </Switch>
        </div>
      </Router>
    </>
  );
}

export default App;
